import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router';

import {
    ContentTitle,
} from '@src/components/common/Display/titles';
import { ProductUpdatesCardRow } from '@src/components/products';

/**
 * ArticleView Promo card for articles
 * @param {object} productArticles Redux training courses data
 */

export const ProductUpdates = (props) => {
    const {
        productUpdates,
        product,
    } = props;

    if (!productUpdates) return null;

    let link = '';

    if (product) {
        link = `/products/product-news-and-updates/?option=${product}&type=product`;
    } else {
        link = '/products/product-news-and-updates/';
    }

    return (
        <>
            <Row>
                <Col sm={12}>
                    <ContentTitle
                        title="Recent Product Updates"
                    />
                </Col>
            </Row>

            <ProductUpdatesCardRow
                productArticles={productUpdates}
            />
            <Row>
                <Col className="text-center">
                    <Link to={link} className="btn btn-primary">
                        View All
                    </Link>
                </Col>
            </Row>
        </>
    );
};

ProductUpdates.propTypes = {
    productUpdates: PropTypes.arrayOf(
        PropTypes.object,
    ).isRequired,
    product: PropTypes.string,
};
